export function getRoleValue(roleLike) {
  if (!roleLike) return null;
  if (typeof roleLike === "string") return roleLike;
  return roleLike.rol || roleLike.detalle || null;
}

export function getDefaultRole(user) {
  return getRoleValue(user?.rolDefault);
}

export function getModuleRole(user, key) {
  return getRoleValue(user?.[key]);
}

export function userHasAnyRole(user, roles) {
  if (!roles || roles.length === 0) return true;
  return roles.includes(getDefaultRole(user));
}

export function userIsDistribuidor(user) {
  return getDefaultRole(user) === "Distribuidor";
}

export function userIsVisualizador(user) {
  return getDefaultRole(user) === "Visualizador";
}

export function userIsAccesoMercado(user) {
  return getDefaultRole(user) === "AccesoMercado";
}

export function userIsCobranzas(user) {
  return getDefaultRole(user) === "Cobranzas";
}

const performanceModules = ["rolClientes", "rolCYO", "rolPOG", "rolCC"];

export function userIsPerformance(user) {
  if (!user) return false;

  return performanceModules.some(
    (apiKey) => getModuleRole(user, apiKey) === "Performance",
  );
}

// Calculado en back (Usuario.isContentEditor): Performance en Mi Alta/CYO/POG/CC o email habilitado.
export function userIsContentEditor(user) {
  return !!user?.contentEditor;
}

const moduleRoleMap = {
  micuenta: "rolClientes",
  mialta: "rolClientes",
  mi_alta: "rolClientes",
  mitienda: "rolClientes",
  weboficial: "rolClientes",
  cyo: "rolCYO",
  mispedidos: "rolPedidos",
  pedidos: "rolPedidos",
  cc: "rolCC",
  pog: "rolPOG",
  simulador: "rolPlanComercial",
  planes: "rolPlanComercial",
};

export function getRoleByModule(module, user) {
  const roleKey = moduleRoleMap[module];
  if (!roleKey) return "-";

  return getModuleRole(user, roleKey) ?? "-";
}
